module.exports = __webpack_public_path__ + "static/bg4-025b11a00a14e4ab666d5e50a545a182.jpg";